import { useCallback as e, useEffect as t, useState as n, useMemo as r, useRef as o } from "react";
import c from "@studio-freight/tempus";
import i from "just-debounce-it";
import { createNanoEvents as u } from "nanoevents";
function s(n, r) {
  const o = e(e => {
    n.current && !n.current.contains(e.target) && r();
  }, [n, r]);
  t(() => {
    if (n.current) return document.addEventListener("mousedown", o), () => {
      document.removeEventListener("mousedown", o);
    };
  }, [o, n]);
}
function a() {
  const [e, r] = n(!1);
  return t(() => {
    r(!0);
  }, []), e;
}
function d() {
  const e = a();
  return r(() => {
    if (!e) return;
    const t = window.location,
      n = t.href,
      r = new URLSearchParams(t.search),
      o = n.includes("#debug") || n.includes("/_debug") || r.has("debug") || "development" === process.env.NODE_ENV,
      c = n.includes("#production") || r.has("production");
    return o && !c;
  }, [e]);
}
function l() {
  const [e, r] = n();
  return t(() => {
    function e() {
      r(document.readyState);
    }
    return document.addEventListener("readystatechange", e, !1), e(), () => document.removeEventListener("readystatechange", e, !1);
  }, []), e;
}
function f(e, n = 0) {
  t(() => {
    if (e) return c.add(e, n), () => c.remove(e);
  }, [e, n]);
}
function h({
  root: r = null,
  rootMargin: c = "0px",
  threshold: i = 0,
  once: u = !1,
  lazy: s = !1,
  callback: a = () => {}
} = {}, d = []) {
  const l = o({}),
    [f, h] = n({}),
    [m, v] = n();
  t(() => {
    if (!m) return;
    const e = new IntersectionObserver(([t]) => {
      s ? l.current = t : h(t), a(t), u && t.isIntersecting && e.disconnect();
    }, {
      root: r,
      rootMargin: c,
      threshold: i
    });
    return e.observe(m), () => {
      e.disconnect();
    };
  }, [m, r, c, i, s, u, ...d]);
  const w = e(() => l.current, []);
  return [v, s ? w : f];
}
function m(e, n = 1e3, r = []) {
  t(() => {
    const t = setInterval(e, n);
    return () => clearInterval(t);
  }, [n, ...r]);
}
function v() {
  const [e, r] = n();
  return t(() => {
    function e() {
      r("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
    }
    return window.addEventListener("resize", e, !1), e(), () => {
      window.removeEventListener("resize", e, !1);
    };
  }, []), e;
}
function w(e) {
  const [r, o] = n();
  return t(() => {
    const t = window.matchMedia(e);
    function n() {
      o(t.matches);
    }
    return t.addEventListener("change", n, !1), n(), () => t.removeEventListener("change", n, !1);
  }, [e]), r;
}
function g() {
  return g = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g.apply(this, arguments);
}
function p(e) {
  "sticky" === getComputedStyle(e).position && (e.style.setProperty("position", "static"), e.dataset.sticky = "true"), e.offsetParent && p(e.offsetParent);
}
function b(e) {
  var t;
  "true" === (null == e || null == (t = e.dataset) ? void 0 : t.sticky) && (e.style.removeProperty("position"), e.dataset.sticky = "true", delete e.dataset.sticky), e.parentNode && b(e.parentNode);
}
function y(e, t = 0) {
  const n = t + e.offsetTop;
  return e.offsetParent ? y(e.offsetParent, n) : n;
}
function z(e, t = 0) {
  const n = t + e.offsetLeft;
  return e.offsetParent ? z(e.offsetParent, n) : n;
}
function P(e, t = 0) {
  const n = t + e.scrollTop;
  return e.offsetParent ? P(e.offsetParent, n) : n + window.scrollY;
}
function E(e, t = 0) {
  const n = t + e.scrollLeft;
  return e.offsetParent ? E(e.offsetParent, n) : n + window.scrollX;
}
const L = u();
function k({
  ignoreTransform: r = !1,
  ignoreSticky: c = !0,
  debounce: u = 500,
  lazy: s = !1,
  callback: a
} = {}) {
  const [d, l] = n(),
    f = o({}),
    [h, m] = n({}),
    v = e(({
      top: e,
      left: t,
      width: n,
      height: r,
      element: o
    }) => {
      var c, i, u, d, l;
      e = null != (c = e) ? c : f.current.top, t = null != (i = t) ? i : f.current.left, n = null != (u = n) ? u : f.current.width, r = null != (d = r) ? d : f.current.height, o = null != (l = o) ? l : f.current.element, e === f.current.top && t === f.current.left && n === f.current.width && r === f.current.height && o === f.current.element || (f.current.top = e, f.current.y = e, f.current.width = n, f.current.height = r, f.current.left = t, f.current.x = t, f.current.bottom = e + r, f.current.right = t + n, f.current.element = o, null == a || a(f.current), s || m(g({}, f.current)));
    }, [s]);
  t(() => {
    if (!d) return;
    const e = d.getBoundingClientRect();
    v({
      width: e.width,
      height: e.height
    });
    const t = i(([e]) => {
        v({
          width: e.borderBoxSize[0].inlineSize,
          height: e.borderBoxSize[0].blockSize
        });
      }, u),
      n = new ResizeObserver(t);
    return n.observe(d), () => {
      n.disconnect(), t.cancel();
    };
  }, [d, u, v]);
  const [w, k] = n(),
    x = e(() => {
      if (!d) return;
      let e, t;
      if (c && p(d), r) e = y(d), t = z(d);else {
        const n = d.getBoundingClientRect();
        e = n.top + P(d), t = n.left + E(d);
      }
      c && b(d), v({
        top: e,
        left: t,
        element: d
      });
    }, [r, c, d, v]);
  t(() => {
    x();
    const e = i(x, u),
      t = new ResizeObserver(e);
    return t.observe(null != w ? w : document.body), () => {
      t.disconnect(), e.cancel();
    };
  }, [w, u, x]), t(() => L.on("resize", function () {
    if (!d) return;
    const e = d.getBoundingClientRect();
    v({
      width: e.width,
      height: e.height
    }), x();
  }), [d, x, v]);
  const O = e(() => f.current, []);
  return [l, s ? O : h, k];
}
function x({
  lazy: r = !1,
  debounce: c = 500,
  box: u = "border-box",
  callback: s = () => {}
} = {}) {
  const a = o({}),
    [d, l] = n({}),
    [f, h] = n();
  t(() => {
    if (!f) return;
    const e = i(([e]) => {
        a.current = e, s(e), r || l(e);
      }, c, !0),
      t = new ResizeObserver(e);
    return t.observe(f, {
      box: u
    }), () => {
      t.disconnect(), e.cancel();
    };
  }, [f, r, c, u]);
  const m = e(() => a.current, []);
  return [h, r ? m : d];
}
function O(e = [], t = []) {
  const n = r(() => t && [t].flat(), [t]),
    o = r(() => e && [e].flat(), [e]);
  return r(() => {
    if (!n || !o) return;
    const t = o.map(e => {
      var t;
      return null == (t = n.find(t => t.type === e)) ? void 0 : t.props.children;
    });
    return e[0] ? t : t[0];
  }, [n, o]);
}
function S(e = 500) {
  const [r, o] = n(),
    [c, u] = n();
  return t(() => {
    const t = i(() => {
      o(Math.min(window.innerWidth, document.documentElement.clientWidth)), u(Math.min(window.innerHeight, document.documentElement.clientHeight));
    }, e);
    return window.addEventListener("resize", t, !1), t(), () => window.removeEventListener("resize", t, !1);
  }, [e]), {
    width: r,
    height: c
  };
}
k.resize = () => {
  L.emit("resize");
};
export { d as useDebug, l as useDocumentReadyState, f as useFrame, h as useIntersectionObserver, m as useInterval, a as useIsClient, v as useIsTouchDevice, w as useMediaQuery, s as useOutsideClickEvent, k as useRect, x as useResizeObserver, O as useSlots, S as useWindowSize };